import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Form } from 'react-bootstrap';

import { STYLE_TYPES } from '../../../api/Styles/Styles';
import { getRasterOpacityPercentage, getSLD } from '../../../api/Styles/style-operations';
import StyleOpacityField from '../StyleOpacityField';

const LayerRasterField = ({ styleType, style }) => {
  if (STYLE_TYPES.RASTER === styleType) {
    return (
      <>
        <StyleOpacityField alpha={getRasterOpacityPercentage(style)} isLayerOpacity />
        {!isEmpty(getSLD(style)) && (
          <Form.Group>
            <Form.Label>External SLD</Form.Label>
            <Form.Control value={getSLD(style)} readOnly name="externalSLD" />
          </Form.Group>
        )}
      </>
    );
  }
  return '';
};

LayerRasterField.propTypes = {
  style: PropTypes.object.isRequired,
  styleType: PropTypes.string.isRequired
};

export default LayerRasterField;
